(() => {
  const root = document.documentElement;
  let scheduled = false;
  const selectors = '#Details-menu-drawer-container[open], details-modal details[open], cart-drawer.active, .quick-add-modal[open], pickup-availability-drawer[open], .klaviyo-form[aria-modal="true"], #shopify-pc__banner, [role="dialog"][aria-modal="true"]';
  const visible = (element) => {
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.visibility !== 'hidden' && style.opacity !== '0' && rect.width > 8 && rect.height > 8 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  };
  const update = () => {
    scheduled = false;
    const open = [...document.querySelectorAll(selectors)].some(visible);
    root.classList.toggle('bonk-interface-open', open);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  const start = () => {
    const purchases = document.querySelectorAll('.product__info-container, .quick-add, .bonk-depts, .bonk-entry, .bonk-hero__cta, .bonk-grid, .bonk-footer');
    const seen = new Set();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.isIntersecting ? seen.add(entry.target) : seen.delete(entry.target));
      root.classList.toggle('bonk-shopping-in-view', seen.size > 0);
    }, {rootMargin: '48px 0px'});
    purchases.forEach((element) => observer.observe(element));
    const mutations = new MutationObserver(schedule);
    mutations.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'aria-modal', 'style']});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
